import { useHasBeenIdentified } from "./useState";
import { micromark as orignalMicromark} from 'micromark'
import metadata from '@/appVersion.json'


// Helper function to check if we should trigger the shortcut
export const isValidTarget = (event: KeyboardEvent) => {
  const activeElement = document.activeElement as HTMLElement
  const tagName = activeElement?.tagName?.toLowerCase()

  // Don't trigger if user is typing in an input, textarea, select, or content editable element
  if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || activeElement?.contentEditable === 'true') {
    return false
  }

  // Don't trigger if modifier keys are pressed (cmd, ctrl, alt, shift)
  if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) {
    return false
  }

  return true
}

export const generateID = (length:number = 12, numberOnly: boolean = false) => {

  let alphabet
  if(numberOnly) {
    alphabet = '0123456789';
  } else {
    alphabet = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  }

	var rtn = '';
	for (var i = 0; i < length; i++) {
	  rtn += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
	}
	return rtn; 
}


export const getLang = () => {
  return (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language;
}

// export const getCookieSettings = () => {
// 	let localSettings = JSON.parse(localStorage.getItem("cookieConsent"))
// 	let settings = {
// 		completed: localSettings ? true : false,
// 		data: localSettings || {
// 			perf: false,
// 			req: true
// 		}
// 	}

// 	return settings
// }

// docs

export const micromark = orignalMicromark

export const validatePermission = (permissionType, resourceType, enterpriseId = null) => {

  const supabaseUserData = useSupabaseUserData();

  const user_roles = supabaseUserData.value?.user_roles || []

  return user_roles.some(role => {

    // Check if enterpriseId is provided and matches, or if it's not provided at all
    const enterpriseMatch = enterpriseId === null || role.enterprise_id === enterpriseId;
    if (!enterpriseMatch) return false;

    // Check roles and permissions
    return role.roles.role_permissions.some(permission => {
      return permission.permissions.permission_type === permissionType &&
        permission.permissions.resource_type === resourceType;
    });
  });
}

export const sleep = (ms:number) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}


export const identifyUser = async(userData:any) => {

  console.log("identifyUser disabled:", userData)

  // const hasBeenIdentified = useHasBeenIdentified()

  // if(hasBeenIdentified.value) {
    // console.log("User already identified")
  // } else {
    
    // console.log("Identifying user:", userData))

    // const { $posthog } = useNuxtApp()
    
    // try {

    //   if(!$posthog?.identify) throw "Posthog not loaded"
  
    //   $posthog.identify(userData.id)
  
    //   let logRequest = await $fetch('/api/log', {
    //     method: "POST",
    //     body:{
    //       type: 'identify',
    //       userID: userData.id,
    //       email: userData.email
    //     }
    //   })

    //   hasBeenIdentified.value = true
  
    // } catch (error) {
    //   console.log("Error logging:", error)
    // }
  // }

}

export const trackEvent = async(event:{name:string, userID:string, properties?:object}) => {

	console.log("Tracking event (not setup yet):", event)

	// try {
  //   let logRequest = await $fetch('/api/log', {
  //     method: "POST",
  //     body:{
	// 			type: 'event',
	// 			name: event.name,
  //       userID: event.userID,
	// 			properties: event.properties || {}
  //     }
  //   })

  // } catch (error) {
  //   console.log("Error logging:", error)
  // }

}

export const handleGoogleCredentialResponse = async function (response) {
  
  console.log("handleCredentialResponse:", response)

  const { $supabase } = useNuxtApp()

  const { data, error } = await $supabase.auth.signInWithIdToken({
    token: response.credential,
    provider: 'google'
  })

  if(error) {
    console.log("Error signing in with Google:", error)
    toast.error("Something went wrong!")
  }

  if(data && data.user && data.session) {
    const supabaseUser = useSupabaseUser()
    supabaseUser.value = data.session.user

    identifyUser(data.session.user)

    await getUserData(data.session.user.id)

    console.log("Google sign in successful:", data)
    toast.success("Signed in successfully!")
  }
  
}


export const dataURLtoBlob = function(dataurl) {
  const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export const isTouchDevice = function () {
  return (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));
}

export const checkVersion = async function () {

  console.log("Checking app version")

  const supabaseUser = useSupabaseUser()
  const appVersionStatus = useAppVersionStatus()

  // API GET request to /api/version with current version of the app in query params
  // Use fetch to get the version of the app
  let response = await fetch(`/api/version`)

  // check if the response is ok
  if (!response.ok) {
    console.error(`Error fetching version`)
    return
  }

  // parse the response as json
  let data = await response.json()

  // check if the version of the app is different from the version in the server
  if (data.build !== metadata.build) {

    // console.log(`Build mismatch`)

    // send signal to prompt user to reload if they haven't already ignored it
    if (appVersionStatus.value !== 'ignored') {
      appVersionStatus.value = 'warnUser'
      trackEvent({
        name: "Build Mismatch, user notified to refresh page",
        userID: supabaseUser.value?.id || null,
        properties: {
          currentBuild: metadata.build,
          serverBuild: data.build
        }
      })
    }

  }
}

